
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"rankingLojas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ano"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"response"},"name":{"kind":"Name","value":"relatorioRankingLojas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ano"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ano"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ilp_id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"posicao"},"name":{"kind":"Name","value":"ilp_rnk"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"early"},"name":{"kind":"Name","value":"ilp_early_churn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filial"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"fiag_id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"nome"},"name":{"kind":"Name","value":"nome_filial_ranking"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"receita_fixa"},"name":{"kind":"Name","value":"ilp_fixa"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"receita_sva"},"name":{"kind":"Name","value":"ilp_sva"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"receita_movel"},"name":{"kind":"Name","value":"ilp_movel"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"receita_terminais"},"name":{"kind":"Name","value":"ilp_terminais"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"receita_total"},"name":{"kind":"Name","value":"ilp_total"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"classificacao"},"name":{"kind":"Name","value":"ilp_classificacao"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"plus_normal"},"name":{"kind":"Name","value":"ilp_plus_normal"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"classificacao_final"},"name":{"kind":"Name","value":"ilp_final"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":538}};
    doc.loc.source = {"body":"query rankingLojas($ano: Int!) {\n    response: relatorioRankingLojas(ano: $ano) {\n        id: ilp_id\n        posicao: ilp_rnk\n        early: ilp_early_churn\n        filial {\n            id: fiag_id\n            nome: nome_filial_ranking\n        }\n        receita_fixa: ilp_fixa\n        receita_sva: ilp_sva\n        receita_movel: ilp_movel\n        receita_terminais: ilp_terminais\n        receita_total: ilp_total\n        classificacao: ilp_classificacao\n        plus_normal: ilp_plus_normal\n        classificacao_final: ilp_final\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["rankingLojas"] = oneQuery(doc, "rankingLojas");
        
